import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import { usePlayerMenuStore } from "@/domains/playerMenu/store";

export default function useShowPlayerMenu() {
  const { setIsShow, isShow } = usePlayerMenuStore();

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Player.ShowMenu, () => {
      setIsShow(true);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Player.ShowMenu);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Player.HideMenu, () => {
      setIsShow(false);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Player.HideMenu);
    };
  }, []);

  return {
    isShow,
  };
}
